/*@ngInject*/
const EndorsementActionsMediator = function (endorsementActionRepository) {

    this.getEndorsementSummary = function (endorsementId) {
        return endorsementActionRepository.getEndorsementSummary(endorsementId);
    };

    this.delete = function (endorsementId) {
        return endorsementActionRepository.deleteEndorsement(endorsementId);
    };

    this.create = function (endorsementId) {
        return endorsementActionRepository.create(endorsementId);
    };

    this.submit = function (endorsementId) {
        return endorsementActionRepository.submit(endorsementId);
    };

    this.startRating = function (endorsementId) {
        return endorsementActionRepository.startRating(endorsementId);
    };

    this.refreshQuote = function (endorsementId) {
        return endorsementActionRepository.refreshQuote(endorsementId);
    };

    this.submitForIssuance = function (endorsementId) {
        return endorsementActionRepository.submitForIssuance(endorsementId);
    };

    this.markIssued = function (endorsementId) {
        return endorsementActionRepository.markIssued(endorsementId);
    };

    this.revertToSubmitted = function (endorsementId) {
        return endorsementActionRepository.revertToSubmitted(endorsementId);
    };

    this.approve = function (endorsementId, processingInstructions) {
        return endorsementActionRepository.approve(endorsementId, processingInstructions);
    };

    this.decline = function (endorsementId, reason, detail) {
        return endorsementActionRepository.decline(endorsementId, reason, detail);
    };

    this.generateRating = function (endorsementId) {
        return endorsementActionRepository.generateRating(endorsementId);
    };

    this.generateRatingAttachments = function (endorsementId, attachmentsToGenerate) {
        return endorsementActionRepository.generateRatingAttachments(endorsementId, attachmentsToGenerate);
    }

    this.startPricing = function (endorsementId) {
        return endorsementActionRepository.startPricing(endorsementId);
    };

    this.modifyPricing = function (endorsementId) {
        return endorsementActionRepository.modifyPricing(endorsementId);
    };

    this.modifyRating = function (endorsementId) {
        return endorsementActionRepository.modifyRating(endorsementId);
    };

    this.revertToPendingIssuance = function (endorsementId) {
        return endorsementActionRepository.revertToPendingIssuance(endorsementId);
    };


};

angular.module('gw-um-submission')
    .service('endorsementActionsMediator', EndorsementActionsMediator);
